import {
  type FillLayerSpecification,
  type LineLayerSpecification,
} from '@aus-platform/cesium';
import { type ComplianceAssessmentType } from './types';

export const complianceAssessmentInitialState: ComplianceAssessmentType = {
  comparisonIteration: null,
  excavationZoneLayers: null,
  dumpZoneLayers: null,
  sectionLineLayers: null,
  plannedExcavationQuantity: null,
  plannedDumpQuantity: null,
};

export const polygonLayersTemplate: (
  | FillLayerSpecification
  | LineLayerSpecification
)[] = [
  {
    id: 'polygons',
    type: 'fill',
    source: '',
    'source-layer': 'default',
    paint: {
      'fill-color': '#F9CC34',
      'fill-opacity': 0,
    },
    filter: ['==', 'type', 'Polygon'],
  },
  {
    id: 'polygon-boundary',
    type: 'line',
    source: '',
    'source-layer': 'default',
    paint: {
      'line-color': '#F9CC34',
      'line-width': 3,
    },
    filter: ['==', 'type', 'Polygon'],
  },
];

export const lineLayersTemplate: LineLayerSpecification[] = [
  {
    id: 'lines',
    source: '',
    'source-layer': 'default',
    type: 'line',
    paint: {
      'line-color': '#F9CC34',
      'line-width': 3,
    },
    filter: ['==', 'type', 'LineString'],
  },
];
